import React from 'react';

import type { IBaseProps } from '@home/types/common';

interface IListRenderGuideProps extends IBaseProps {
  list?: any[] | null;
}

const ListRenderGuide: React.FC<IListRenderGuideProps> = (props) => {
  const { list, children } = props;

  if (!Array.isArray(list) || !list.length) return null;

  return children;
};

export default React.memo(ListRenderGuide);
